import { Alert, Box, IconButton, Typography } from "@mui/material";
import { Component } from "react";
import { BsExclamationOctagonFill, BsExclamationTriangleFill, BsFillCaretDownFill, BsFillCheckCircleFill, BsXLg } from "react-icons/bs";

export default class StatusAlert extends Component {

    constructor(props) {
        super(props);
        if (props.type === "err") {
            this.alert = {
                title: 'Erro',
                color: 'error',
                icon: <BsExclamationOctagonFill style={{ fontSize: 20 }} />
            }
        } else if (props.type === "warn") {
            this.alert = {
                title: 'Aviso',
                color: 'warning',
                icon: <BsExclamationTriangleFill style={{ fontSize: 20 }} />
            }
        } else {
            this.alert = {
                title: 'Sucesso',
                color: 'success',
                icon: <BsFillCheckCircleFill style={{ fontSize: 20 }} />
            }
        }

        this.state = {
            showExtra: false
        }
    }

    render() {
        return (
            <Alert key={this.alert.title} severity={this.alert.color}>
                <Box>
                    <b>{this.alert.title}</b>
                    <Typography level="body-sm" color={this.alert.color}>
                        {this.props.msg}
                    </Typography>
                    {this.props.type === "err" && <>
                        {!this.state.showExtra ? (<IconButton color={this.alert.color} sx={{ mt: 1, fontSize: 10 }} size="sm" onClick={() => this.setState({ showExtra: true })}>VER MAIS DETALHES<BsFillCaretDownFill style={{ marginLeft: 2 }} /></IconButton>)
                            : (<Typography sx={{ fontSize: 11 }} color={this.alert.color}>
                                {this.props.extra}
                            </Typography>)
                        }
                    </>}
                </Box>
            </Alert >
        );
    }
}